/**
 * Scheuch Process Designer
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { SeuApiOfferDto } from '../model/offerDto';
// @ts-ignore
import { SeuApiSaveOperatingCondition } from '../model/saveOperatingCondition';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { SeuApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateOperatingConditionRequestParams {
  offerId: string;
  interconnectionId: number;
  seuApiSaveOperatingCondition: SeuApiSaveOperatingCondition;
}

export interface DeleteOperatingConditionRequestParams {
  offerId: string;
  interconnectionId: number;
  operatingConditionId: number;
}

export interface DuplicateOperatingConditionRequestParams {
  offerId: string;
  interconnectionId: number;
  operatingConditionId: number;
  title: string;
}

export interface MarkOperatingConditionAsActiveRequestParams {
  offerId: string;
  interconnectionId: number;
  operatingConditionId: number;
}

export interface UpdateOperatingConditionRequestParams {
  offerId: string;
  interconnectionId: number;
  operatingConditionId: number;
  seuApiSaveOperatingCondition: SeuApiSaveOperatingCondition;
}

@Injectable({
  providedIn: 'root',
})
export class OperatingConditionsRestControllerApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: SeuApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * @endpoint post /offers/{offerId}/interconnections/{interconnectionId}/operatingConditions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOperatingCondition(
    requestParameters: CreateOperatingConditionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOfferDto>;
  public createOperatingCondition(
    requestParameters: CreateOperatingConditionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOfferDto>>;
  public createOperatingCondition(
    requestParameters: CreateOperatingConditionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOfferDto>>;
  public createOperatingCondition(
    requestParameters: CreateOperatingConditionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling createOperatingCondition.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling createOperatingCondition.'
      );
    }
    const seuApiSaveOperatingCondition =
      requestParameters?.seuApiSaveOperatingCondition;
    if (
      seuApiSaveOperatingCondition === null ||
      seuApiSaveOperatingCondition === undefined
    ) {
      throw new Error(
        'Required parameter seuApiSaveOperatingCondition was null or undefined when calling createOperatingCondition.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingConditions`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOfferDto>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveOperatingCondition,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint delete /offers/{offerId}/interconnections/{interconnectionId}/operatingConditions/{operatingConditionId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOperatingCondition(
    requestParameters: DeleteOperatingConditionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOfferDto>;
  public deleteOperatingCondition(
    requestParameters: DeleteOperatingConditionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOfferDto>>;
  public deleteOperatingCondition(
    requestParameters: DeleteOperatingConditionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOfferDto>>;
  public deleteOperatingCondition(
    requestParameters: DeleteOperatingConditionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling deleteOperatingCondition.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling deleteOperatingCondition.'
      );
    }
    const operatingConditionId = requestParameters?.operatingConditionId;
    if (operatingConditionId === null || operatingConditionId === undefined) {
      throw new Error(
        'Required parameter operatingConditionId was null or undefined when calling deleteOperatingCondition.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingConditions/${this.configuration.encodeParam({ name: 'operatingConditionId', value: operatingConditionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOfferDto>(
      'delete',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint post /offers/{offerId}/interconnections/{interconnectionId}/operatingConditions/{operatingConditionId}/duplicate
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateOperatingCondition(
    requestParameters: DuplicateOperatingConditionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOfferDto>;
  public duplicateOperatingCondition(
    requestParameters: DuplicateOperatingConditionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOfferDto>>;
  public duplicateOperatingCondition(
    requestParameters: DuplicateOperatingConditionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOfferDto>>;
  public duplicateOperatingCondition(
    requestParameters: DuplicateOperatingConditionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling duplicateOperatingCondition.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling duplicateOperatingCondition.'
      );
    }
    const operatingConditionId = requestParameters?.operatingConditionId;
    if (operatingConditionId === null || operatingConditionId === undefined) {
      throw new Error(
        'Required parameter operatingConditionId was null or undefined when calling duplicateOperatingCondition.'
      );
    }
    const title = requestParameters?.title;
    if (title === null || title === undefined) {
      throw new Error(
        'Required parameter title was null or undefined when calling duplicateOperatingCondition.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>title,
      'title'
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingConditions/${this.configuration.encodeParam({ name: 'operatingConditionId', value: operatingConditionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/duplicate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOfferDto>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint put /offers/{offerId}/interconnections/{interconnectionId}/operatingConditions/{operatingConditionId}/active
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public markOperatingConditionAsActive(
    requestParameters: MarkOperatingConditionAsActiveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOfferDto>;
  public markOperatingConditionAsActive(
    requestParameters: MarkOperatingConditionAsActiveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOfferDto>>;
  public markOperatingConditionAsActive(
    requestParameters: MarkOperatingConditionAsActiveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOfferDto>>;
  public markOperatingConditionAsActive(
    requestParameters: MarkOperatingConditionAsActiveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling markOperatingConditionAsActive.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling markOperatingConditionAsActive.'
      );
    }
    const operatingConditionId = requestParameters?.operatingConditionId;
    if (operatingConditionId === null || operatingConditionId === undefined) {
      throw new Error(
        'Required parameter operatingConditionId was null or undefined when calling markOperatingConditionAsActive.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingConditions/${this.configuration.encodeParam({ name: 'operatingConditionId', value: operatingConditionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/active`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOfferDto>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @endpoint put /offers/{offerId}/interconnections/{interconnectionId}/operatingConditions/{operatingConditionId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOperatingCondition(
    requestParameters: UpdateOperatingConditionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiOfferDto>;
  public updateOperatingCondition(
    requestParameters: UpdateOperatingConditionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiOfferDto>>;
  public updateOperatingCondition(
    requestParameters: UpdateOperatingConditionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiOfferDto>>;
  public updateOperatingCondition(
    requestParameters: UpdateOperatingConditionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling updateOperatingCondition.'
      );
    }
    const interconnectionId = requestParameters?.interconnectionId;
    if (interconnectionId === null || interconnectionId === undefined) {
      throw new Error(
        'Required parameter interconnectionId was null or undefined when calling updateOperatingCondition.'
      );
    }
    const operatingConditionId = requestParameters?.operatingConditionId;
    if (operatingConditionId === null || operatingConditionId === undefined) {
      throw new Error(
        'Required parameter operatingConditionId was null or undefined when calling updateOperatingCondition.'
      );
    }
    const seuApiSaveOperatingCondition =
      requestParameters?.seuApiSaveOperatingCondition;
    if (
      seuApiSaveOperatingCondition === null ||
      seuApiSaveOperatingCondition === undefined
    ) {
      throw new Error(
        'Required parameter seuApiSaveOperatingCondition was null or undefined when calling updateOperatingCondition.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/interconnections/${this.configuration.encodeParam({ name: 'interconnectionId', value: interconnectionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/operatingConditions/${this.configuration.encodeParam({ name: 'operatingConditionId', value: operatingConditionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiOfferDto>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveOperatingCondition,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }
}
